// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Bisb from "../../core/Bisb.js";
import * as Buhta_cabinet__Button from "../../components/html/Button.js";
import * as Buhta_cabinet__CalendarDatePickerInput from "../../components/molecules/CalendarDatePickerInput.js";
import * as Buhta_cabinet__Control from "../../grpc/Control.js";
import * as Buhta_cabinet__CurrencyView from "../../components/html/CurrencyView.js";
import * as Buhta_cabinet__Date from "../../util/Date.js";
import * as Buhta_cabinet__Dropdown from "../../components/html/Dropdown.js";
import * as Buhta_cabinet__Dropdowns from "../../components/molecules/Dropdowns.js";
import * as Buhta_cabinet__Field from "../../components/html/Field.js";
import * as Buhta_cabinet__FieldValidationErrorWrapper from "../../components/html/FieldValidationErrorWrapper.js";
import * as Buhta_cabinet__Form from "../../core/Form.js";
import * as Buhta_cabinet__FormView from "../../components/html/FormView.js";
import * as Buhta_cabinet__GrpcFieldErrorWrapper from "../../components/molecules/GrpcFieldErrorWrapper.js";
import * as Buhta_cabinet__LoadingSpinner from "../../components/atoms/LoadingSpinner.js";
import * as Buhta_cabinet__Org from "../../models/Org.js";
import * as Buhta_cabinet__PhoneField from "../../components/html/PhoneField.js";
import * as Buhta_cabinet__RadioButton from "../../components/html/RadioButton.js";
import * as Buhta_cabinet__Select from "../../components/html/Select.js";
import * as Buhta_cabinet__ToastSender from "../../util/ToastSender.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_controlapis__Buhta_control_v1alpha1_org_service from "../../../../../proto/controlapis/gen/buhta_control_v1alpha1_org_service.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../packages/core/lib/Toast.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../packages/util/lib/DateTime.js";
import * as Formating from "../../../../../packages/util/lib/Formating.js";
import * as $$Promise from "../../../../../vendored/promise/promise.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import DropdownArrowSvg from "static/icons/dropdown-arrow.svg";
import KazakhstanRoundSvg from "static/icons/kazakhstan-round.svg";
import KyrgyzstanSvg from "static/icons/kyrgyzstan.svg";
import QuestionSvg from "static/icons/question.svg";
import UzbekistanSvg from "static/icons/uzbekistan.svg";

function currencyIcon(param) {
  if (param !== 57) {
    if (param !== 63) {
      if (param !== 125) {
        return JsxRuntime.jsx(QuestionSvg, {});
      } else {
        return JsxRuntime.jsx(UzbekistanSvg, {
                    className: "rounded-xl"
                  });
      }
    } else {
      return JsxRuntime.jsx(KyrgyzstanSvg, {
                  className: "rounded-xl"
                });
    }
  } else {
    return JsxRuntime.jsx(KazakhstanRoundSvg, {});
  }
}

function make(currency) {
  return function (onCountrySelect) {
    return function (className) {
      const match = React.useState(function () {
            return false;
          });
      const setIsDropdownShown = match[1];
      const activator = function (param) {
        const Key = Buhta_cabinet__CurrencyView.symbol(currency, "default");
        return JsxRuntime.jsxs("div", {
                    children: [
                      currencyIcon(currency),
                      JsxRuntime.jsx(Buhta_components__Text.P.make, {
                            className: "ml-3",
                            children: Buhta_cabinet__CurrencyView.symbol(currency, "text")
                          }),
                      JsxRuntime.jsx(DropdownArrowSvg, {})
                    ],
                    className: "h-full flex items-center animate-fadeIn border border-gray-main rounded py-[11px] px-4"
                  }, Key);
      };
      return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
                  className: Cn.fromList({
                        hd: "flex items-center",
                        tl: {
                          hd: Cn.take(className),
                          tl: /* [] */0
                        }
                      }),
                  align: "BottomRight",
                  activator: activator,
                  background: "bg-white",
                  isDropdownShown: match[0],
                  setIsDropdownShown: setIsDropdownShown,
                  children: JsxRuntime.jsx("div", {
                        children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex({
                                  hd: /* KZT */57,
                                  tl: {
                                    hd: /* UZS */125,
                                    tl: {
                                      hd: /* KGS */63,
                                      tl: /* [] */0
                                    }
                                  }
                                }, (function (index, currency) {
                                    const Key = "country-" + String(index);
                                    return JsxRuntime.jsxs("div", {
                                                children: [
                                                  currencyIcon(currency),
                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                        children: Buhta_cabinet__CurrencyView.symbol(currency, "text")
                                                      })
                                                ],
                                                className: "flex items-center space-x-2 px-4 py-2 hover:bg-gray-light cursor-pointer",
                                                onClick: (function (param) {
                                                    Curry._1(onCountrySelect, currency);
                                                    Curry._1(setIsDropdownShown, (function (param) {
                                                            return false;
                                                          }));
                                                  })
                                              }, Key);
                                  }))),
                        className: "py-4 flex flex-col"
                      })
                });
    };
  };
}

function OrgCreatePage$CurrencyDropdown(Props) {
  return Curry._1(make(Props.currency)(Props.onCountrySelect), Props.className);
}

const CurrencyDropdown = {
  currencyIcon: currencyIcon,
  make: OrgCreatePage$CurrencyDropdown
};

function make$1(banks) {
  return function (selectedBank) {
    return function (onBankSelected) {
      if (typeof banks === "string") {
        return JsxRuntime.jsx(Buhta_cabinet__LoadingSpinner.make, {});
      } else if (banks.NAME === "Data") {
        return JsxRuntime.jsx(Buhta_cabinet__Select.make, {
                    className: "mt-4",
                    options: Belt__Belt_List.map(banks.VAL, (function (bank) {
                            return {
                                    value: bank.bic,
                                    text: bank.name
                                  };
                          })),
                    label: "Банк",
                    size: "m",
                    selectedOption: Belt__Belt_Option.map(selectedBank, (function (bank) {
                            return {
                                    value: bank.bic,
                                    text: bank.name
                                  };
                          })),
                    onChange: onBankSelected
                  });
      } else {
        return "ошибка при подгрузке банков";
      }
    };
  };
}

function OrgCreatePage$BanksSelect(Props) {
  return Curry._1(make$1(Props.banks)(Props.selectedBank), Props.onBankSelected);
}

const BanksSelect = {
  make: OrgCreatePage$BanksSelect
};

function make$2(country) {
  return function (orgTypeField) {
    const func = Buhta_cabinet__Control.OrgService.getOrgTypes;
    const match = Buhta_core__GrpcState.useGrid((function (param) {
            return Curry._2(func, param, country);
          }), undefined);
    const fetchOrgTypes = match[1];
    const orgTypes = match[0];
    React.useEffect((function () {
            Curry._3(fetchOrgTypes, undefined, undefined, undefined);
          }), [country]);
    if (typeof orgTypes === "string") {
      return JsxRuntime.jsx(Buhta_cabinet__LoadingSpinner.make, {
                  size: "s"
                });
    }
    if (orgTypes.NAME !== "Data") {
      return "ошибка при загрузке списка";
    }
    const __x = orgTypes.VAL.types;
    return JsxRuntime.jsx(Buhta_cabinet__Select.make, {
                options: Belt__Belt_List.map(__x, (function (orgType) {
                        return {
                                value: orgType["type'"],
                                text: orgType.name
                              };
                      })),
                label: "Вид деятельности",
                size: "m",
                selectedOption: orgTypeField.value,
                onChange: orgTypeField.onChange
              });
  };
}

function OrgCreatePage$OrgTypeSelect(Props) {
  return make$2(Props.country)(Props.orgTypeField);
}

const OrgTypeSelect = {
  make: OrgCreatePage$OrgTypeSelect
};

function make$3(bankAccount) {
  return function (banks) {
    return function (onChange) {
      const form = Buhta_cabinet__Form.useForm(function (acc) {
            Curry._1(onChange, acc);
            return $$Promise.resolved({
                        TAG: /* Ok */0,
                        _0: undefined
                      });
          });
      const bankAccountCurrencyField = Buhta_cabinet__Form.useField(form, /* KZT */57, undefined, (function (value) {
              if (value) {
                return {
                        TAG: /* Ok */0,
                        _0: value
                      };
              } else {
                return {
                        TAG: /* Error */1,
                        _0: "Выберите валюту"
                      };
              }
            }));
      const match = bankAccount.bic;
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                className: "text-default-gray",
                                children: "Реквизиты"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "IBAN",
                                        size: "m",
                                        onChange: (function (value) {
                                            Curry._1(onChange, (function (param) {
                                                    return {
                                                            iban: value,
                                                            bic: bankAccount.bic,
                                                            open_date: bankAccount.open_date,
                                                            default: bankAccount.default
                                                          };
                                                  }));
                                          }),
                                        className: "flex-1",
                                        value: bankAccount.iban
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__FieldValidationErrorWrapper.make, {
                                        field: bankAccountCurrencyField,
                                        children: JsxRuntime.jsx(OrgCreatePage$CurrencyDropdown, {
                                              currency: bankAccountCurrencyField.value,
                                              onCountrySelect: bankAccountCurrencyField.onChange
                                            })
                                      })
                                ],
                                className: "flex gap-4 items-center mt-4"
                              }),
                          JsxRuntime.jsx(OrgCreatePage$BanksSelect, {
                                banks: banks,
                                selectedBank: typeof banks === "string" || banks.NAME !== "Data" ? undefined : Belt__Belt_List.getBy(banks.VAL, (function (bank) {
                                          return bank.bic === match;
                                        })),
                                onBankSelected: (function (value) {
                                    Curry._1(onChange, (function (param) {
                                            if (value !== undefined) {
                                              return {
                                                      iban: bankAccount.iban,
                                                      bic: value.value,
                                                      open_date: bankAccount.open_date,
                                                      default: bankAccount.default
                                                    };
                                            } else {
                                              return bankAccount;
                                            }
                                          }));
                                  })
                              })
                        ],
                        className: "p-10"
                      }),
                  className: "bg-white shadow-sm rounded-sm w-140.5 mt-2"
                });
    };
  };
}

function OrgCreatePage$BankAccountComponent(Props) {
  return Curry._1(make$3(Props.bankAccount)(Props.banks), Props.onChange);
}

const BankAccountComponent = {
  make: OrgCreatePage$BankAccountComponent
};

function make$4(onClose) {
  return function (onItemCreated) {
    const match = Buhta_core__Tenant.useTenant(undefined);
    const tenant = match[0];
    const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
    const dispatchToasts = match$1[1];
    const form = Buhta_cabinet__Form.useForm(function (param) {
          return $$Promise.resolved({
                      TAG: /* Ok */0,
                      _0: undefined
                    });
        });
    const match$2 = Buhta_core__GrpcState.useGrid(Buhta_cabinet__Bisb.BankService.getBanks, undefined);
    const dispatch = match$2[1];
    React.useEffect((function () {
            Curry._3(dispatch, undefined, undefined, undefined);
          }), []);
    const match$3 = React.useState(function () {
          return /* [] */0;
        });
    const match$4 = React.useState(function () {
          return false;
        });
    const setIsLookingUpForOrg = match$4[1];
    const binField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
            if (value.length === 12) {
              return {
                      TAG: /* Ok */0,
                      _0: value
                    };
            } else {
              return {
                      TAG: /* Error */1,
                      _0: "Номер должен быть 12 значным"
                    };
            }
          }));
    const countryField = Buhta_cabinet__Form.useField(form, /* COUNTRY_KAZ */1, undefined, (function (value) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          }));
    const orgTypeField = Buhta_cabinet__Form.useField(form, undefined, undefined, (function (value) {
            if (value !== undefined) {
              return {
                      TAG: /* Ok */0,
                      _0: value
                    };
            } else {
              return {
                      TAG: /* Error */1,
                      _0: "Выберите тип организации"
                    };
            }
          }));
    const isResidentField = Buhta_cabinet__Form.useField(form, true, undefined, (function (value) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          }));
    const orgNameField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          }));
    const orgEmailField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          }));
    const orgAddressField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          }));
    const orgPhoneField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          }));
    const chiefTinField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
            if (value.length === 12) {
              return {
                      TAG: /* Ok */0,
                      _0: value
                    };
            } else {
              return {
                      TAG: /* Error */1,
                      _0: "Номер должен быть 12 значным"
                    };
            }
          }));
    const chiefPositionField = Buhta_cabinet__Form.useField(form, "Директор", undefined, (function (value) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          }));
    const isChiefResidentField = Buhta_cabinet__Form.useField(form, true, undefined, (function (value) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          }));
    const chiefFamilyNameField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          }));
    const chiefGivenNameField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          }));
    const chiefPatronymicNameField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          }));
    const match$5 = React.useState(function () {
          return "simplified";
        });
    const setTaxMode = match$5[1];
    const taxMode = match$5[0];
    const taxKogdField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          }));
    const match$6 = React.useState(function () {
          return false;
        });
    const setHasVat = match$6[1];
    const hasVat = match$6[0];
    const vatPercentField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          }));
    const vatCertSeriesField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          }));
    const vatCertNumberField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          }));
    const vatCertIssueDateField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          }));
    const emptyBankAccount = {
      iban: "",
      bic: "",
      open_date: undefined,
      default: true
    };
    const match$7 = React.useState(function () {
          return emptyBankAccount;
        });
    const bankAccount = match$7[0];
    React.useEffect((function () {
            Curry._1(orgTypeField.onChange, undefined);
          }), [countryField.value]);
    const injectLookupValues = function (org) {
      Curry._1(orgTypeField.onChange, {
            value: org["type'"],
            text: Buhta_cabinet__Org.Type.toString(org["type'"])
          });
      Curry._1(orgNameField.onChange, org.name);
      Curry._1(orgAddressField.onChange, org.address);
      Curry._1(isResidentField.onChange, org.resident);
      const chief = org.chief;
      if (chief !== undefined) {
        Curry._1(chiefTinField.onChange, chief.tin);
        Curry._1(isChiefResidentField.onChange, chief.resident);
        Curry._1(chiefFamilyNameField.onChange, chief.family_name);
        Curry._1(chiefGivenNameField.onChange, chief.given_name);
        Curry._1(chiefPatronymicNameField.onChange, chief.patronymic_name);
      }
      const tax = org.tax;
      if (tax === undefined) {
        return Curry._1(setHasVat, (function (param) {
                      return false;
                    }));
      }
      Curry._1(taxKogdField.onChange, tax.kogd);
      const vat = tax.vat;
      if (vat !== undefined) {
        Curry._1(setHasVat, (function (param) {
                return true;
              }));
        Curry._1(vatCertNumberField.onChange, vat.vat_number);
        return Curry._1(vatCertSeriesField.onChange, vat.vat_series);
      } else {
        return Curry._1(setHasVat, (function (param) {
                      return false;
                    }));
      }
    };
    return JsxRuntime.jsx(Buhta_cabinet__FormView.make, {
                onSubmit: (function (param) {
                    try {
                      const match = Curry._1(form.validate, undefined);
                      const match$1 = orgTypeField.value;
                      if (match && match$1 !== undefined) {
                        const formData = Curry.app(Buhta_controlapis__Buhta_control_v1alpha1_org_service.Buhta.Control.V1alpha1.OrgData.make, [
                              countryField.value,
                              binField.value,
                              match$1.value,
                              isResidentField.value,
                              orgNameField.value,
                              orgEmailField.value,
                              orgPhoneField.value,
                              orgAddressField.value,
                              chiefTinField.value,
                              isResidentField.value,
                              chiefPositionField.value,
                              chiefFamilyNameField.value,
                              chiefGivenNameField.value,
                              chiefPatronymicNameField.value,
                              undefined,
                              taxKogdField.value,
                              hasVat,
                              vatPercentField.value,
                              vatCertSeriesField.value,
                              vatCertNumberField.value,
                              Buhta_cabinet__Date.fromString(vatCertIssueDateField.value),
                              Caml_obj.caml_equal(bankAccount, emptyBankAccount) ? /* [] */0 : ({
                                    hd: bankAccount,
                                    tl: /* [] */0
                                  }),
                              undefined
                            ]);
                        const __x = Buhta_cabinet__Control.OrgService.create(tenant, formData);
                        return $$Promise.get(__x, (function (result) {
                                      if (result.TAG !== /* Ok */0) {
                                        return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при отправке формы");
                                      }
                                      Curry._1(onItemCreated, result._0.id);
                                      Curry._1(dispatchToasts, {
                                            TAG: /* Add */0,
                                            _0: {
                                              id: Buhta_core__Toast.generateId(undefined),
                                              text: "Предприятие успешно создано",
                                              kind: "success",
                                              onClick: (function (param) {
                                                  
                                                })
                                            }
                                          });
                                    }));
                      }
                      return Curry._1(dispatchToasts, {
                                  TAG: /* Add */0,
                                  _0: {
                                    id: Buhta_core__Toast.generateId(undefined),
                                    text: "Проверьте введенные данные",
                                    kind: "warning",
                                    onClick: (function (param) {
                                        
                                      })
                                  }
                                });
                    }
                    catch (raw_exceptions){
                      const exceptions = Caml_js_exceptions.internalToOCamlException(raw_exceptions);
                      console.log("exceptions", exceptions);
                      return Curry._1(dispatchToasts, {
                                  TAG: /* Add */0,
                                  _0: {
                                    id: Buhta_core__Toast.generateId(undefined),
                                    text: "Unexpected exception",
                                    kind: "warning",
                                    onClick: (function (param) {
                                        
                                      })
                                  }
                                });
                    }
                  }),
                className: "overflow-auto",
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_cabinet__Dropdowns.CountrySelect.make, {
                                            setCountryCode: countryField.onChange
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__GrpcFieldErrorWrapper.make, {
                                            errors: match$3[0],
                                            field: "tin",
                                            children: JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                  label: "БИН / ИИН",
                                                  size: "m",
                                                  required: true,
                                                  onChange: (function (value) {
                                                      Curry._1(binField.onChange, value);
                                                      if (value.length === 12 && countryField.value === /* COUNTRY_KAZ */1) {
                                                        Curry._1(setIsLookingUpForOrg, (function (param) {
                                                                return true;
                                                              }));
                                                        const __x = Buhta_cabinet__Control.EntityService.lookup(value, countryField.value, /* LOOKUP_CTX_ORG */1);
                                                        return $$Promise.get(__x, (function (response) {
                                                                      if (response.TAG === /* Ok */0) {
                                                                        injectLookupValues(response._0);
                                                                      } else {
                                                                        Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, response._0, "Ошибка при поиске");
                                                                      }
                                                                      Curry._1(setIsLookingUpForOrg, (function (param) {
                                                                              return false;
                                                                            }));
                                                                    }));
                                                      }
                                                      
                                                    }),
                                                  className: "mt-4",
                                                  validatedValue: binField.valueForDisplay,
                                                  value: binField.value
                                                })
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__FieldValidationErrorWrapper.make, {
                                            field: orgTypeField,
                                            className: "mt-4",
                                            children: JsxRuntime.jsx(OrgCreatePage$OrgTypeSelect, {
                                                  country: countryField.value,
                                                  orgTypeField: orgTypeField
                                                })
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                            label: "Название компании",
                                            size: "m",
                                            required: true,
                                            onChange: orgNameField.onChange,
                                            className: "mt-4",
                                            validatedValue: orgNameField.valueForDisplay,
                                            value: orgNameField.value
                                          })
                                    ],
                                    className: "p-10"
                                  }),
                              className: "bg-white shadow-sm rounded-sm w-140.5"
                            }),
                        match$4[0] ? JsxRuntime.jsx(Buhta_cabinet__LoadingSpinner.make, {}) : JsxRuntime.jsxs(React.Fragment, {
                                children: [
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                      label: "Адрес",
                                                      size: "m",
                                                      onChange: orgAddressField.onChange,
                                                      validatedValue: orgAddressField.valueForDisplay,
                                                      value: orgAddressField.value
                                                    }),
                                                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                      label: "Email",
                                                      size: "m",
                                                      onChange: orgEmailField.onChange,
                                                      className: "mt-4",
                                                      validatedValue: orgEmailField.valueForDisplay,
                                                      value: orgEmailField.value
                                                    }),
                                                JsxRuntime.jsx(Buhta_cabinet__FieldValidationErrorWrapper.make, {
                                                      field: orgPhoneField,
                                                      children: JsxRuntime.jsx(Buhta_cabinet__PhoneField.make, {
                                                            value: Formating.formatPhone(orgPhoneField.value),
                                                            onChange: orgPhoneField.onChange,
                                                            className: "mt-4"
                                                          })
                                                    })
                                              ],
                                              className: "p-10"
                                            }),
                                        className: "bg-white shadow-sm rounded-sm w-140.5 mt-2"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                                      className: "text-default-gray",
                                                      children: "Руководитель"
                                                    }),
                                                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                      label: "Позиция",
                                                      size: "m",
                                                      onChange: chiefPositionField.onChange,
                                                      className: "mt-4",
                                                      validatedValue: chiefPositionField.valueForDisplay,
                                                      value: chiefPositionField.value
                                                    }),
                                                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                      label: "Фамилия",
                                                      size: "m",
                                                      required: true,
                                                      onChange: chiefFamilyNameField.onChange,
                                                      className: "mt-4",
                                                      validatedValue: chiefFamilyNameField.valueForDisplay,
                                                      value: chiefFamilyNameField.value
                                                    }),
                                                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                      label: "Имя",
                                                      size: "m",
                                                      required: true,
                                                      onChange: chiefGivenNameField.onChange,
                                                      className: "mt-4",
                                                      validatedValue: chiefGivenNameField.valueForDisplay,
                                                      value: chiefGivenNameField.value
                                                    }),
                                                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                      label: "Отчество",
                                                      size: "m",
                                                      onChange: chiefPatronymicNameField.onChange,
                                                      className: "mt-4",
                                                      validatedValue: chiefPatronymicNameField.valueForDisplay,
                                                      value: chiefPatronymicNameField.value
                                                    }),
                                                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                      label: "ИИН",
                                                      size: "m",
                                                      required: true,
                                                      onChange: chiefTinField.onChange,
                                                      className: "mt-4",
                                                      validatedValue: chiefTinField.valueForDisplay,
                                                      value: chiefTinField.value
                                                    })
                                              ],
                                              className: "p-10"
                                            }),
                                        className: "bg-white shadow-sm rounded-sm w-140.5 mt-2"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                                      className: "text-default-gray",
                                                      children: "Режим налогообложения"
                                                    }),
                                                JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                      className: "mt-4",
                                                      checked: taxMode === "simplified",
                                                      onChange: (function (param) {
                                                          Curry._1(setTaxMode, (function (param) {
                                                                  return "simplified";
                                                                }));
                                                        }),
                                                      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "ml-2",
                                                            children: "Упрощенный"
                                                          })
                                                    }),
                                                JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                      className: "mt-2",
                                                      checked: taxMode === "standard",
                                                      onChange: (function (param) {
                                                          Curry._1(setTaxMode, (function (param) {
                                                                  return "standard";
                                                                }));
                                                        }),
                                                      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "ml-2",
                                                            children: "Общеустановленный"
                                                          })
                                                    }),
                                                JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                                      className: "mt-6 text-default-gray",
                                                      children: "Ндс"
                                                    }),
                                                JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                      className: "mt-4",
                                                      checked: hasVat,
                                                      onChange: (function (param) {
                                                          Curry._1(setHasVat, (function (param) {
                                                                  return true;
                                                                }));
                                                        }),
                                                      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "ml-2",
                                                            children: "С НДС"
                                                          })
                                                    }),
                                                JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                      className: "mt-2",
                                                      checked: !hasVat,
                                                      onChange: (function (param) {
                                                          Curry._1(setHasVat, (function (param) {
                                                                  return false;
                                                                }));
                                                        }),
                                                      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "ml-2",
                                                            children: "Без НДС"
                                                          })
                                                    }),
                                                hasVat ? JsxRuntime.jsxs(React.Fragment, {
                                                        children: [
                                                          JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                                label: "Процент",
                                                                size: "m",
                                                                required: true,
                                                                onChange: vatPercentField.onChange,
                                                                className: "mt-4",
                                                                validatedValue: vatPercentField.valueForDisplay,
                                                                value: vatPercentField.value
                                                              }),
                                                          JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                                label: "Серия",
                                                                size: "m",
                                                                required: true,
                                                                onChange: vatCertSeriesField.onChange,
                                                                className: "mt-4",
                                                                validatedValue: vatCertSeriesField.valueForDisplay,
                                                                value: vatCertSeriesField.value
                                                              }),
                                                          JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                                label: "Номер НДС",
                                                                size: "m",
                                                                required: true,
                                                                onChange: vatCertNumberField.onChange,
                                                                className: "mt-4",
                                                                validatedValue: vatCertNumberField.valueForDisplay,
                                                                value: vatCertNumberField.value
                                                              }),
                                                          JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  JsxRuntime.jsx(Buhta_components__Text.P.make, {
                                                                        className: "text-default-gray",
                                                                        children: "Дата выдачи:"
                                                                      }),
                                                                  JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                                        value: vatCertIssueDateField.value,
                                                                        onPicked: (function (date) {
                                                                            Curry._1(vatCertIssueDateField.onChange, DateTime.toDateFormat(date));
                                                                          })
                                                                      })
                                                                ],
                                                                className: "flex justify-end gap-4 items-center mt-4"
                                                              })
                                                        ]
                                                      }) : null,
                                                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                      label: "Код ОГД",
                                                      size: "m",
                                                      onChange: taxKogdField.onChange,
                                                      className: "mt-4",
                                                      validatedValue: taxKogdField.valueForDisplay,
                                                      value: taxKogdField.value
                                                    })
                                              ],
                                              className: "p-10"
                                            }),
                                        className: "bg-white shadow-sm rounded-sm w-140.5 mt-2"
                                      }),
                                  JsxRuntime.jsx(OrgCreatePage$BankAccountComponent, {
                                        bankAccount: bankAccount,
                                        banks: match$2[0],
                                        onChange: match$7[1]
                                      })
                                ]
                              }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                                    kind: "primary",
                                    state: form.isSubmitting ? "Loading" : "Default",
                                    type_: "submit",
                                    disabled: form.isSubmitting,
                                    children: "Создать"
                                  }),
                              className: "w-140.5 flex justify-end mt-6"
                            })
                      ],
                      className: "bg-gray-pale flex flex-col items-center pt-6 pb-60"
                    })
              });
  };
}

function OrgCreatePage(Props) {
  return make$4(Props.onClose)(Props.onItemCreated);
}

const make$5 = OrgCreatePage;

export {
  CurrencyDropdown ,
  BanksSelect ,
  OrgTypeSelect ,
  BankAccountComponent ,
  make$5 as make,
}
/* Buhta_cabinet__Bisb Not a pure module */
